import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import './LegalPage.css';

const CONTACT_EMAIL = 'flashagency1@outlook.com';
const CONTACT_PHONE = '+852 52134313';

function RefundPolicy() {
  const { t } = useI18n();

  return (
    <div className="legal-page">
      <h1 className="legal-page__title">{t('legal.refund.title')}</h1>
      <p className="legal-page__subtitle">{t('legal.refund.subtitle')}</p>

      <section className="legal-page__section">
        <h2>{t('legal.refund.timelineTitle')}</h2>
        <p>{t('legal.refund.timelineText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.refund.availableTitle')}</h2>
        <ul>
          <li>{t('legal.refund.availableItem1')}</li>
          <li>{t('legal.refund.availableItem2')}</li>
          <li>{t('legal.refund.availableItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.refund.unavailableTitle')}</h2>
        <ul>
          <li>{t('legal.refund.unavailableItem1')}</li>
          <li>{t('legal.refund.unavailableItem2')}</li>
          <li>{t('legal.refund.unavailableItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.refund.arrivalTitle')}</h2>
        <p>{t('legal.refund.arrivalText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.refund.processTitle')}</h2>
        <ul>
          <li>{t('legal.refund.processItem1')}</li>
          <li>{t('legal.refund.processItem2')}</li>
          <li>{t('legal.refund.processItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.refund.shippingTitle')}</h2>
        <p>{t('legal.refund.shippingText')}</p>
      </section>

      <section className="legal-page__section legal-page__contact">
        <h2>{t('legal.contact.title')}</h2>
        <p>{t('footer.title')}</p>
        <p>{t('footer.companyName')}</p>
        <p>{t('footer.address')}</p>
        <p>
          {t('footer.emailLabel')}: {CONTACT_EMAIL}
        </p>
        <p>
          {t('footer.phoneLabel')}: {CONTACT_PHONE}
        </p>
      </section>
    </div>
  );
}

export default RefundPolicy;
